module.exports = __webpack_public_path__ + "img/cofree_bmpm.gm.c48044b.png";